import React, { useEffect, useState } from "react";
import styles from "./dashboard.module.scss";
import * as constants from "../../../src/utils/constant";
import * as utils from "../../utils/utils";
import CustDashboard from "./CustDashboard";
import GroupDashboard from "./GroupDashboard";
import ProdDivDashboard from "./ProdDivDashboard";
import SubRegDashboard from "./SubRegDashboard";
//import FavDashboard from "./FavDashboard";
import StrategicAcctDashboard from "./StrategicAcctDashboard";

const LoadJSON = (props) => {
    const { region } = props;
    console.log("Selected Region---LoadJson ", region);
    const [data, setData] = useState({})
    const [isLoading, setIsLoading] = useState(false);//Need to investigate on isLoading
    const [defaultSelectedRegion] = useState("NA");//EMEA Release-
    const [dashboardData, setDashboardData] = useState(null);//EMEA Release-
    const [subRegionData, setSubRegionData] = useState(null);//EMEA Release-
    const [selectedRegion, setSelectedRegion] = useState(JSON.parse(sessionStorage.getItem("selectedRegion")));//EMEA Release-

    const processData = (fetchedData, reg) => {
        console.log("processd Data fetched Data", fetchedData);
        console.log("processd Data region", reg);
        //code Added for EMEA release - to fetch specific group based on region selection
        const selectedRegionIndex = fetchedData.group.findIndex((item) => item.company_region.toLowerCase() === reg.toLowerCase())
        const group = fetchedData.group[selectedRegionIndex]
        
        //const { group } = fetchedData;  //commented for EMEA release
        group.cxBenchmark = group.cxGroupBenchmark;
        group.casBenchmark = group.casGroupBenchmark;
        group.primaryRecommendation = Array.isArray(group.primaryRecommendation) ? group.primaryRecommendation[0] : group.primaryRecommendation;
        const productDivisions = [...group.productDivisions];
        productDivisions.forEach((element) => {
            element.name = element.name.toUpperCase();
            element.cxBenchmark = group.cxProductDivisionBenchmark;
            element.casBenchmark = group.casProductDivisionBenchmark;
            element.primaryRecommendation = Array.isArray(element.primaryRecommendation) ? element.primaryRecommendation[0] : element.primaryRecommendation;//EMEA Release- Added this
        });
        productDivisions.sort(utils.sorting('code', 'string', true))

        const customers = [...group.customers];
        customers.sort(utils.sorting('name', 'string', true))
        customers.forEach((element) => {
            element.name = utils.capitalize(element.name.trim())
            element.cxBenchmark = group.cxCustomerBenchmark;
            element.casBenchmark = group.casCustomerBenchmark;
        });
        //const strategicAccounts = fetchedData.group[selectedRegionIndex];
        const strategicAccounts = group.strategicAccounts[0];
        return { group, productDivisions, customers, strategicAccounts }

    };

    //EMEA Release-- code for new JSON structure changes
    const getGroupData = (result, region) => {
        const group = result.hits.hits[0];
        const customerObject = group.inner_hits['group.customers'].hits;
        let new_array = []
        if (customerObject && customerObject.hits && customerObject.hits.length > 0) {
            const customerFilteredArray = customerObject.hits.filter((item) => item.fields['group.customers.company_region.keyword'][0] === region)
            new_array = customerFilteredArray.map(function callback(element) {
                let custObj = {};
                custObj.company_region = (element.fields['group.customers.company_region.keyword']) ? element.fields['group.customers.company_region.keyword'][0] : '-';
                custObj['name'] = (element.fields['group.customers.name.keyword']) ? element.fields['group.customers.name.keyword'][0] : '-';
                custObj.cxScore = (element.fields['group.customers.cxScore']) ? element.fields['group.customers.cxScore'][0] : '-';
                custObj.lastQuarterCxScore = (element.fields['group.customers.lastQuarterCxScore']) ? element.fields['group.customers.lastQuarterCxScore'][0] : '-';
                custObj.code = (element.fields['group.customers.code.keyword']) ? element.fields['group.customers.code.keyword'][0] : '-';
                custObj.lastQuarterCas = (element.fields['group.customers.lastQuarterCas']) ? element.fields['group.customers.lastQuarterCas'][0] : '-';
                custObj.responseCount = (element.fields['group.customers.responseCount']) ? element.fields['group.customers.responseCount'][0] : '-';
                custObj.id = (element.fields['group.customers.id']) ? element.fields['group.customers.id'][0] : '-';
                custObj.name = (element.fields['group.customers.name.keyword']) ? element.fields['group.customers.name.keyword'][0] : '-';
                custObj.cas = (element.fields['group.customers.cas']) ? element.fields['group.customers.cas'][0] : '-';
                //custObj.volatility = (element.fields['group.customers.volatility.keyword']) ? element.fields['group.customers.volatility.keyword'][0] : '-';
                custObj.primaryRecommendation = (element.fields['group.customers.primaryRecommendation.keyword']) ? element.fields['group.customers.primaryRecommendation.keyword'][0] : '-';
                custObj.secondaryRecommendations = (element.fields['group.customers.secondaryRecommendations.keyword']) ? element.fields['group.customers.secondaryRecommendations.keyword'] : [];
                custObj.whiteGlove = (element.fields['group.customers.whiteGlove.keyword']) ? element.fields['group.customers.whiteGlove.keyword'][0] : '-';
                return custObj
            })
        }

        const selectedRegionIndex = group['_source'].group.findIndex((item) => item.company_region === region)
        group['_source'].group[selectedRegionIndex].customers = new_array;
        console.log("getGroupData Result is----", group['_source'])
        return group['_source'];
    }
    //On initial load - fetch NA and EMEA data including customers data

    useEffect(() => {
        //EMEA Release- - Default selection to NA on load
        let region = selectedRegion ? selectedRegion : defaultSelectedRegion
        sessionStorage.setItem("selectedRegion", JSON.stringify(region));
        setSelectedRegion(region)  //EMEA Release- ends here
        //props.setRegion(region);  //NEED TO LOOK WHILE REFACTORING
        const input = {
            name: constants.Group_Dashboard_Index,
            queryParams: {
                "_source": {
                    "excludes": ["*.customers"]
                },
                "query": {
                    "nested": {
                        "path": "group.customers",
                        "query": {
                            "match": {
                                "group.customers.whiteGlove": "true"
                            }
                        },
                        "inner_hits": {
                            "_source": false,
                            "size": 100,//modified for EMEA release
                            "docvalue_fields": [
                                "group.customers.company_region.keyword",//added for EMEA release
                                "group.customers.code.keyword",
                                "group.customers.name.keyword",
                                "group.customers.id",
                                "group.customers.cxScore",
                                "group.customers.lastQuarterCxScore",
                                "group.customers.lastQuarterCas",
                                "group.customers.responseCount",
                                "group.customers.cas",
                                //"group.customers.volatility.keyword",
                                "group.customers.primaryRecommendation.keyword",
                                "group.customers.secondaryRecommendations.keyword",
                                "group.customers.whiteGlove.keyword"
                            ]
                        }
                    }
                }
            }
        }
        setIsLoading(true)
        utils.getDataES('-elasticsearch', 'POST', input)
            .then(resp => {
                setDashboardData(resp.data);
                parseData(resp.data, region);
                props.isDataLoaded(true);
                // myPDCarouselChange(); //NEED TO LOOK WHILE REFACTORING
                //myCustCarouselChange();  //NEED TO LOOK WHILE REFACTORING
            }).catch(err => setIsLoading(false))
        //initialLoadArrow();
        lastUpdatedDttmBanner();
        props.setCustomer({})
        props.setSelectedSBS({})
        props.setProductDivision({})
        props.setSubRegion({})//added for EMEA release
        props.setKPI({});
        // getFavorites();
    }, [])

    useEffect(() => {
        console.log("It should be called whenever there is changes in dashboardData  or region---", "dashboardData", dashboardData)
        if (dashboardData)
            parseData(dashboardData, region)
    }, [region])

    const lastUpdatedDttmBanner = () => {
        const input = {
            name: constants.Ingestion_Status_Load_Index,
            queryParams: {}
        }
        setIsLoading(true)
        utils.getDataES('-elasticsearch', 'POST', input)
            .then(resp => {
                let lastDttmUpd = resp.data.hits.hits[0]._source.latest_date;
                console.log("Ingestion_Status_Load Http Response--lastUpddate", lastDttmUpd)
                props.setBannerLastUpdDt(lastDttmUpd);
            }).catch(err => setIsLoading(false))
    }

    //fetch Subregion API
    const processSubRegionData = () => {
        let subRegion;
        const subRegionInput = {
            name: constants.SubRegion_Dashboard_Index,
            queryParams: {}
        }
        setIsLoading(true)
        utils.getDataES('-elasticsearch', 'POST', subRegionInput)
            .then(subRegresp => {
                subRegion = subRegresp.data.hits.hits[0]['_source'].group;
                subRegion.forEach((element) => {
                    // element.code = element.name.toUpperCase();
                    element.companycodes = Array.isArray(element.companycodes) ? element.companycodes.join(",") : "";
                    element.code = utils.capitalize(element.code.trim())
                    element.cxBenchmark = element.cxProductDivisionBenchmark;
                    element.casBenchmark = element.casProductDivisionBenchmark;
                    element.primaryRecommendation = Array.isArray(element.primaryRecommendation) ? element.primaryRecommendation[0] : element.primaryRecommendation;
                });
                subRegion.sort(utils.sorting('code', 'string', true))
                props.setSubRegion(subRegion)
                setSubRegionData(subRegion)
                setIsLoading(false)
            }).catch(err => setIsLoading(false))
    }

    /*EMEA Release- - New method added which calls subsequent methods to process based on region selected */
    const parseData = (dbData, region) => {
        console.log("I am inside Parse-Data--", "dbData is", dbData)
        if (JSON.parse(sessionStorage.getItem("selectedRegion")).toLowerCase() === 'emea') {
            processSubRegionData();
        }
        else {
            setSubRegionData([])
        }

        let groupESData = getGroupData(dbData, region);//if strategic accounts data send in InnerHits like they send customer data
        let result = processData(groupESData, region);//Directly we can write here-if strategic account data send in Source.
        console.log("In parseData method-- process-Data final result---", result)
        setData(JSON.parse(JSON.stringify(result)))
        setIsLoading(false);
    }

    return (<>
        <div className={styles.GrpPrdContainer}>
            {data && data.group ? (<GroupDashboard data={data} selectedRegion={region} {...props} />) : null}
            {data && data.productDivisions && data.productDivisions.length ? (<ProdDivDashboard data={data} selectedRegion={region} {...props} />) : null}
            {data && data.group ? (<StrategicAcctDashboard data={data} selectedRegion={region} {...props} />) : null}
            
        </div>
        
        {subRegionData && subRegionData.length > 0 && <SubRegDashboard subRegionData={subRegionData} selectedRegion={region} {...props} />}
        
        
        {data && data.customers && data.customers.length ? (<CustDashboard data={data} selectedRegion={region} {...props} />) : null}
        
        
        </>
    )
}

export default LoadJSON;